import Service from '../Service'
import {http} from '../config'

export default class BancoService extends Service{

    constructor(){
        super('banco');
    }

    Totalizadores(search, columns, filter, include){
        let parametros = this.GetParamentroPaginacaoOrdenacao(null, null, null, [], search, columns, filter);

        if(parametros === '?'){
            parametros = '';
        }

        return http.get(`${this._nomeControle}/Totalizadores${parametros}`, this.GetHeader(include));
    }

}
